import React, { useEffect, useState } from 'react'
import { BackButton, EditButton } from '../../../../Components/Utils/Buttons';
import { Link, useLocation, useParams } from 'react-router-dom';
import axiosInstance from '../../../../Services/axiosCommon';
import { NormalHeading } from '../../../../Components/Utils/Heading';
import CommonComments from '../../../../Components/Utils/commonComments';
import FilesView from '../../../../Components/Utils/FilesView';
import { useFormik } from 'formik';
import Breadcrumb from '../../../../Components/Utils/Breadcrumb';
import { GetAccess } from '../../../../Components/Utils/roles';

function ViewContractors() {
  const { contractorsViewId } = useParams();
  const location = useLocation();
  const cdata = location.state?.data;
       const pageIndex = location.state?.pageIndex;
       const searchQuery = location.state?.searchQuery;
       
       const [data,setData] = useState(cdata? cdata:null); 
  const [percentOpen, setPercentOpen] = useState(false);
   const [createNew, setCreateNew] = useState({
    name:""
  });
  const [expandedIndex, setExpandedIndex] = useState(null);

  const handleToggle = (index) => {
    setExpandedIndex(expandedIndex === index ? null : index);
  };

  const [filePathList, setFilePathList] = useState([]);
 useEffect(() => {
   if (
     data?.attachments !== null &&
     data?.attachments !== "None" &&
     data?.attachments !== "[]"
   ) {
     setFilePathList(data?.attachments?.length>0 ? data?.attachments : []);
   }
 }, [data]);

 function getView() {
  axiosInstance 
    .get(`/suppliers/${contractorsViewId}`)
    .then((res) => {
      setData(res.data?.data);       
    })
    .catch(err=>{
      console.log("err", err);
    })
}

useEffect(() => {
  // if (!cdata) {
    getView();
  // }
}, [])
  
  const formik = useFormik({
    enableReinitialize: true,
    initialValues: createNew,
    validateOnChange: false,
    validateOnBlur: false,
   
    onSubmit: (values) => console.log("Form Submitted", values),
  });
  
  return (
    <div className="w-full h-full py-2 px-4 ">
      <div className="sm:flex justify-between ">
      <Breadcrumb
                  items={[
                    // { name: "Contacts" },
                    {
                      name: "Main-Contractors",
                      link:"/contacts/main-contractors"

                     
                    },
        
                    { name: "View" },
                  ]}
                />
        <div className=" flex gap-2 justify-end">
          <Link
            to={`/contacts/main-contractors`}
            state={{
              currentPage: pageIndex,
              searchQuery: searchQuery != "" ? searchQuery : "",
            }}
          >
            <BackButton link={true} />
          </Link>
          {GetAccess("contacts_edit")&&
          <Link
            to={`/contacts/main-contractors/edit/${contractorsViewId}`}
            state={{
              data: data,
              from: `/contacts/main-contractors/view/${contractorsViewId}`,
            }}
          >
            <EditButton height="8" />
          </Link>}
        </div>
      </div>

      <div className="w-full mx-auto h-[calc(100vh-160px)] drop-shadow-lg mt-4 overflow-y-auto  md:flex gap-x-2 text-[#111537]">
        <div className="lg:w-[70%] md:w-[60%]  bg-white rounded-lg drop-shadow-lg py-1 overflow-hidden ">
          <div className="sm:w-[98%]  bg-white px-2 mx-2 border border-gray py-2 rounded-lg sm:flex justify-between items-center  z-10">
           <div className='flex gap-4'>
          <div className='w-16 bg-slate-50 2xl:w-20  h-16 2xl:h-20 flex justify-center items-center rounded-md border-2  border-baseColor-secondary bg-basColor-quartary border-solid overflow-hidden'>
         {/* <img className='w-full h-auto' src={data?.vendorImage?.file} alt='#' /> */}
         {
  data?.vendorImage?.file ? (
    <img
      src={data.vendorImage?.file}
      alt={`${data?.vendorImage?.file}`}
      className="object-cover"
    />
  ) : (
    <span className="uppercase">
      {data?.companyName?.charAt(0)}
    </span>
  )
}

       </div>
       <div className="grid  items-center ">
               <div className=" mb-1 text-[#111537] font-semibold w-[100%]">
                 <p className="flex text-lg">{data?.companyName}</p>
                 <p className="flex text-[#606279] text-xs">{data?.refNumber}</p>

               </div> 
               {/* <div className="flex gap-4 justify-between">
                 <p className="text-xs text-[#111537]">Date : 05-03-2025</p>
               </div> */}
             </div>
            </div>

             <div className=" flex items-center mt-2 sm:mt-0  overflow-hidden rounded-full text-[10px] 2xl:text-xs  ">
                            <div className="  p-2 h-6  bg-white  rounded-s-full text-xs flex items-center border border-textColor-main">
                              Status{" "}
                            </div>
                            <div className="  p-2 h-6  bg-textColor-main text-white text-xs rounded-e-full flex items-center">
                              {data?.vendorStatus || "-"}
                            </div>
                          </div>
          </div>

          <div className="h-[calc(100vh-200px)] overflow-y-auto p-2 pb-8 ">
            <div className=" w-full flex flex-wrap  px-2 border border-gary mt-2  rounded-lg ">
             {/* {data?.image.file && (
       <div className='w-20 mt-3 h-20 flex justify-center items-center rounded-full border-2  border-baseColor-secondary bg-basColor-quartary border-solid overflow-hidden'>
           <img className='w-full h-auto' src={data?.image?.file} alt='employee' />
         </div>
         )} */}
              <div className=" w-full sm:grid grid-cols-2 gap-x-8 mt-3">
               
              
                <div className="w-full flex px-2">
                  <p className="w-1/3 py-2 text-xs font-medium text-[#111537]">
                  Category
                  </p>
                  <p className="w-[65%] py-2 text-xs font-medium text-[#606279]">
                    : {data?.category}
                  </p>
                </div>
               
                <div className="w-full flex px-2">
                  <p className="w-1/3 py-2 text-xs font-medium text-[#111537]">
                  Type
                  </p>
                  <p className="w-[65%] py-2 text-xs font-medium text-[#606279]">
                    : {data?.vendorType}
                  </p>
                </div>

                <div className="w-full flex px-2">
                  <p className="w-1/3 py-2 text-xs font-medium text-[#111537]">
                  Phone
                  </p>
                  <p className="w-[65%] py-2 text-xs font-medium text-[#606279]">
                    : {data?.phoneWithCC}
                  </p>
                </div>

                <div className="w-full flex px-2">
                  <p className="w-1/3 py-2 text-xs font-medium text-[#111537]">
                  Email
                  </p>
                  <p className="w-[65%] py-2 text-xs font-medium text-[#606279]">
                    : {data?.email}
                  </p>
                </div>
                <div className="w-full flex px-2">
                  <p className="w-1/3 py-2 text-xs font-medium text-[#111537]">
                  Website
                  </p>
                  <p className="w-[65%] py-2 text-xs font-medium text-[#606279]">
                    : {data?.website}
                  </p>
                </div>
                <div className="w-full flex px-2">
                  <p className="w-1/3 py-2 text-xs font-medium text-[#111537]">
                  Tax Id
                  </p>
                  <p className="w-[65%] py-2 text-xs font-medium text-[#606279]">
                    : {data?.taxId}
                  </p>
                </div>
                {/* <div className="w-full flex px-2">
                  <p className="w-1/3 py-2 text-xs font-medium text-[#111537]">
                  Currency
                  </p>
                  <p className="w-[65%] py-2 text-xs font-medium text-[#606279]">
                    : {data?.currencyId}
                  </p>
                </div> */}
                <div className="w-full flex px-2">
                  <p className="w-1/3 py-2 text-xs font-medium text-[#111537]">
                  Payment Terms
                  </p>
                  <p className="w-[65%] py-2 text-xs font-medium text-[#606279]">
                    : {data?.paymentTerms}
                  </p>
                </div>
                <div className="w-full flex px-2">
                  <p className="w-1/3 py-2 text-xs font-medium text-[#111537]">
                  Deliver Terms
                  </p>
                  <p className="w-[65%] py-2 text-xs font-medium text-[#606279]">
                    : {data?.deliverTerms}
                  </p>
                </div>
                <div className="w-full flex px-2">
                  <p className="w-1/3 py-2 text-xs font-medium text-[#111537]">
                  Rating
                  </p>
                  <p className="w-[65%] py-2 text-xs font-medium text-[#606279]">
                    : {data?.performanceRating}
                  </p>
                </div>
               
               
              </div>
            </div>
            <div className='sm:flex gap-4 mt-4'>
            <div className="sm:w-[50%]">
  <p className="text-xs font-medium text-[#111537] p-1">Address</p>

  <div className="border border-gray h-28 overflow-y-scroll rounded-lg">
   
  <div className="text-xs p-2 leading-snug">
  <p>
    {[data?.address1, data?.address2].filter(Boolean).join(', ')}
  </p>
  <p>
    {[data?.city, data?.state, data?.postalCode, data?.country]
      .filter(Boolean)
      .join(', ')}
  </p>
</div>


    
  </div>
</div>
           
             <div className="sm:w-[50%] ">
                <p className="  text-xs font-medium text-[#111537] p-1">
                  Comments
                </p>
                <div className="  border border-gary  h-28 overflow-y-scroll rounded-lg items-center">
                  <p className="  text-xs p-2 break-words text-[#606279]">
                    {data?.comments || "-"}
                  </p>
                </div>
              </div>
              </div>
          

          </div>
        </div>
        <div className="lg:w-[30%] md:w-[40%] bg-white rounded-lg drop-shadow-lg py-1 mt-3 md:mt-0">
          <div className="h-[98%] overflow-y-scroll p-2 ">
            <div className="w-full grid  border border-gary   rounded-lg">
              <div className="bg-baseColor-primary  p-2 rounded-t-lg">
                <p className="text-xs text-white font-medium">Primary Contact</p>
              </div>
              {/* <p className="text-xs text-[#111537] font-medium">Customer Detail</p> */}

              <div className="w-full flex px-2 justify-between">
                <p className="w-[35%] py-2 text-xs font-medium text-[#111537]">
                  Name
                </p>
                <p className="w-[65%] py-2 text-xs font-medium text-[#606279] truncate">
                  : {data?.pcName}
                </p>
              </div>
              <div className="w-full flex px-2 justify-between">
                <p className="w-[35%] py-2 text-xs font-medium text-[#111537]">
                  {" "}
                  Designation
                </p>
                <p className="w-[65%] py-2 text-xs font-medium text-[#606279] truncate">
                  {" "}
                  : {data?.pcDesignation}
                </p>
              </div>
              <div className="w-full flex px-2 justify-between">
                <p className="w-[35%] py-2 text-xs font-medium text-[#111537]">
                  {" "}
                  Mobile
                </p>
                <p className="w-[65%] py-2 text-xs font-medium text-[#606279] truncate">
                  {" "}
                  : {data?.pcMobile}
                </p>
              </div>
              <div className="w-full flex px-2 justify-between">
                <p className="w-[35%] py-2 text-xs font-medium text-[#111537]">
                  {" "}
                  Email
                </p>
                <p className="w-[65%] py-2 text-xs font-medium text-[#606279] truncate">
                  {" "}
                  : {data?.pcEmail}
                </p>
              </div>
            </div>

            {(data?.scName || data?.scDesignation || data?.scMobile || data?.scEmail) && (

            <div className="w-full grid  border border-gary   rounded-lg mt-2">
              <div className="bg-baseColor-primary  p-2 rounded-t-lg">
                <p className="text-xs text-white font-medium">Secondary Contact</p>
              </div>
              {/* <p className="text-xs text-[#111537] font-medium">Customer Detail</p> */}

              <div className="w-full flex px-2 justify-between">
                <p className="w-[35%] py-2 text-xs font-medium text-[#111537]">
                  Name
                </p>
                <p className="w-[65%] py-2 text-xs font-medium text-[#606279] truncate">
                  : {data?.scName}
                </p>
              </div>
              <div className="w-full flex px-2 justify-between">
                <p className="w-[35%] py-2 text-xs font-medium text-[#111537]">
                  {" "}
                  Designation
                </p>
                <p className="w-[65%] py-2 text-xs font-medium text-[#606279] truncate">
                  {" "}
                  : {data?.scDesignation}
                </p>
              </div>
              <div className="w-full flex px-2 justify-between">
                <p className="w-[35%] py-2 text-xs font-medium text-[#111537]">
                  {" "}
                  Mobile
                </p>
                <p className="w-[65%] py-2 text-xs font-medium text-[#606279] truncate">
                  {" "}
                  : {data?.scMobile}
                </p>
              </div>
              <div className="w-full flex px-2 justify-between">
                <p className="w-[35%] py-2 text-xs font-medium text-[#111537]">
                  {" "}
                  Email
                </p>
                <p className="w-[65%] py-2 text-xs font-medium text-[#606279] truncate">
                  {" "}
                  : {data?.scEmail}
                </p>
              </div>
            </div>
            )}

            
            {/* <div className="w-full h-auto flex  border border-gary mt-4 overflow-hidden rounded-lg">
              <CommonComments
                visible={true}
                title="Comments"
                mainId={data?.prId}
                addurl={"/pr-comments/new-comment"}
                geturl={`/pr-comments/by-PR/${data?.prId}`}
              />
            </div> */}
          </div>
        </div>
      </div>
    </div>
  );
}

export default ViewContractors
